module.exports = __webpack_public_path__ + "img/baki-logo.32be2826.png";